// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","panelExt":"notification-panel__panelExt___dKJzn"};